import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import { Outlet } from 'react-router-dom';
import { Toast } from '@heroui/react';
import './i18n';
import { Layout } from './layout';
import { ApiProvider } from './api';
import { ShortcutProvider, shortcutRegistry } from './components/shortcuts';
import { env } from './config/env';
import { QueryDevtools } from './components/queryDevtools';

dayjs.extend(utc);
dayjs.extend(advancedFormat);

/**
 * The API this bundle was built for: the mode's env file sets
 * `BUN_PUBLIC_API_BASE_URL` and the build inlines it (SEL-66, `config/env`).
 */
const API_BASE_URL = env.apiBaseUrl;

export const App: React.FC = () => {
    return (
        <ApiProvider baseUrl={API_BASE_URL}>
            <ShortcutProvider registry={shortcutRegistry}>
                <Layout>
                    <Outlet />
                </Layout>
                <Toast.Provider />
                <QueryDevtools />
            </ShortcutProvider>
        </ApiProvider>
    );
};
